import * as React from "react";
import { forwardRef } from "react";
const SvgRemoveEntry = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.6666 4.27398L11.7266 3.33398L7.99992 7.06065L4.27325 3.33398L3.33325 4.27398L7.05992 8.00065L3.33325 11.7273L4.27325 12.6673L7.99992 8.94065L11.7266 12.6673L12.6666 11.7273L8.93992 8.00065L12.6666 4.27398Z", fill: "#898989" }));
const ForwardRef = forwardRef(SvgRemoveEntry);
export { ForwardRef as ReactComponent };
